// Copyright 2026. WebPros International GmbH. All rights reserved.

import { useMediaQuery } from 'react-responsive';
import {
    BREAKPOINTS,
    Breakpoint,
} from 'common/styles/breakpoints';

const ORDERED_BREAKPOINTS = Object.keys(BREAKPOINTS) as Breakpoint[];

export function useIsUp(px: number): boolean {
    return useMediaQuery({ minWidth: px });
}

export function useIsDown(px: number): boolean {
    return useMediaQuery({ maxWidth: px - 0.05 });
}

export function useIsBetween(min: number, max: number): boolean {
    return useMediaQuery({ minWidth: min, maxWidth: max - 0.05 });
}

export function useIsEqual(key: Breakpoint): boolean {
    const idx = ORDERED_BREAKPOINTS.indexOf(key);
    const next = ORDERED_BREAKPOINTS[idx + 1];

    return useMediaQuery({
        ...(idx === 0 ? {} : { minWidth: BREAKPOINTS[key] }),
        ...(next ? { maxWidth: BREAKPOINTS[next] - 0.05 } : {}),
    });
}
